import axios from 'axios';
import { jwtDecode } from "jwt-decode";

const API_URL = 'https://dittmagasin.no/api/v2';

const BEARER_TOKEN = 'kj5VjcbrNnrYEDxlRgdaEfsP2vm1lnc46F0PKVdwZ7yBdXr77eifamRMI6Lf';

const statisticService = {
  fetchReleaseStatistics: async (releaseId) => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const response = await axios.get(
        `${API_URL}/statistics/release-action`,
        {
          params: { release_id: releaseId },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data?.data || [];
      return response.data;
    } catch (error) {
      console.error('Failed to fetch releases:', error);
      return null;
    }
  },
  fetchMagazineStatistics: async (magazineId) => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const response = await axios.get(
        `${API_URL}/statistics/magazine-action`,
        {
          params: { magazine_id: magazineId },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data?.data || [];
    } catch (error) {
      console.error('Failed to fetch releases:', error);
      return null;
    }
  },
  loadSubscriberStats: async (magazineId, callback) => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const response = await axios.get(
        `${API_URL}/statistics/yearly-subscribers`,
        {
          params: { magazine_id: magazineId },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.data.status) {
        return response.data?.data || [];
        callback(response.data.data);
      } else {
        return [];
        callback([]);
      }
    } catch (error) {
      console.error('Error loading subscriber stats:', error);
      callback([]);
    }
  },
  loadStatistcStats: async (magazineId, callback) => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const response = await axios.get(
        `${API_URL}/statistics/yearly-statistics`,
        {
          params: { magazine_id: magazineId },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.data.status) {
        return response.data?.data || [];
        callback(response.data.data);
      } else {
        return [];
        callback([]);
      }
    } catch (error) {
      console.error('Error loading subscriber stats:', error);
      callback([]);
    }
  },
  getReleaseStatisticsByAction: async (params) => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      const response = await axios.get(
        `${API_URL}/statistics/subscriber-statistics`,
        {
          params: {
            release_id: params.releaseId,
            action: params.action,
            page: params.page,
            per_page: params.perPage,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.data.status) {
        return response?.data || [];
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error loading subscriber stats:', error);
    }
  }
};

export default statisticService;

